import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M13.9147 9.3697C13.9147 9.3697 9.70468 -0.0102975 4.17468 1.0897C1.62468 1.5997 0.844682 4.10971 1.02468 6.49971C1.24468 9.37971 2.74468 12.3097 2.94468 14.2497C3.31468 17.7997 0.36468 25.1497 4.58468 27.1197C9.29468 29.3197 12.2547 21.9697 12.2547 21.9697L13.9147 9.3697Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M4.47509 12.2397C4.47509 12.2397 2.51509 6.39971 4.02509 4.59971C5.53509 2.80971 10.0051 6.02972 9.45508 19.1397"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M4.47486 12.2397C3.65486 10.2697 2.98487 8.18972 3.09487 5.90972C3.15487 5.33972 3.29486 4.71972 3.78486 4.18972C4.02486 3.92972 4.37487 3.73972 4.73487 3.68972C5.10487 3.62972 5.45487 3.69971 5.76487 3.81971C6.96487 4.36971 7.60486 5.38972 8.11486 6.36972C9.09486 8.38972 9.49486 10.5597 9.64486 12.7097C9.80486 14.8597 9.72486 17.0097 9.44486 19.1297C9.33486 16.9897 9.20487 14.8697 8.90487 12.7897C8.57487 10.7197 8.13486 8.63971 7.22486 6.81971C6.77486 5.93971 6.16486 5.04971 5.39486 4.70971C5.01486 4.55971 4.68486 4.57972 4.42486 4.82972C4.15486 5.07972 3.99487 5.53973 3.90487 6.01973C3.73487 6.98973 3.80487 8.05971 3.93487 9.09971C4.06487 10.1497 4.26486 11.1897 4.47486 12.2397Z"
        fill={outline}
      />
      <path
        d="M69.3848 9.3697C69.3848 9.3697 73.5948 -0.0102975 79.1248 1.0897C81.6748 1.5997 82.4548 4.10971 82.2748 6.49971C82.0548 9.37971 80.5548 12.3097 80.3548 14.2497C79.9848 17.7997 82.9348 25.1497 78.7148 27.1197C74.0048 29.3197 71.0448 21.9697 71.0448 21.9697L69.3848 9.3697Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M78.8249 12.2397C78.8249 12.2397 80.7849 6.39971 79.2749 4.59971C77.7649 2.80971 73.2949 6.02972 73.8449 19.1397"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M78.825 12.2397C79.035 11.1897 79.235 10.1497 79.355 9.09971C79.485 8.05971 79.565 6.99973 79.385 6.01973C79.295 5.54973 79.145 5.07972 78.865 4.82972C78.605 4.57972 78.275 4.55971 77.895 4.70971C77.125 5.05971 76.515 5.93971 76.065 6.81971C75.155 8.63971 74.715 10.7197 74.385 12.7897C74.085 14.8797 73.955 16.9997 73.845 19.1297C73.565 17.0097 73.495 14.8597 73.645 12.7097C73.805 10.5597 74.205 8.38972 75.175 6.36972C75.685 5.38972 76.325 4.36971 77.525 3.81971C77.835 3.69971 78.185 3.62972 78.555 3.68972C78.925 3.73972 79.265 3.93972 79.505 4.18972C79.985 4.70972 80.125 5.33972 80.195 5.90972C80.315 8.19972 79.645 10.2697 78.825 12.2397Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.65047 8.50743) rotate(83.6788) scale(7.49835 4.55679)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(74.6561 8.56051) rotate(96.3212) scale(7.49835 4.55679)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
